package ui

import kotlinx.serialization.*

@Serializable
data class ArgsInitial(
    var cat: Int = Category.UNKNOWN.key,
    var sub: Int = Subcategory.UNKNOWN.key,
    var key: String = "",
) {

    val category get() = Category.entries.firstOrNull { it.key == cat } ?: Category.UNKNOWN
    val subcategory get() = Subcategory.entries.firstOrNull { it.key == sub } ?: Subcategory.UNKNOWN

    fun release() {
        cat = Category.UNKNOWN.key
        sub = Subcategory.UNKNOWN.key
        key = ""
    }

    enum class Category(val key: Int) {
        UNKNOWN(-1),
        DEVICE(0);

        companion object {
            fun get(key: String?): Category = runCatching {
                Category.valueOf(key ?: "")
            }.getOrNull() ?: UNKNOWN
        }
    }

    enum class Subcategory(val key: Int) {
        UNKNOWN(-1),
        REGISTRATION(0),
        INFO(1);

        companion object {
            fun get(key: String?): Subcategory = runCatching {
                Subcategory.valueOf(key ?: "")
            }.getOrNull() ?: UNKNOWN
        }
    }
}
